module.exports = __webpack_public_path__ + "static/media/logo-ecobrite-universidade.32653ee5.png";